import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUITextareaPillComponent),
            multi: true
        }
    ],
    selector: "fui-textarea-pill",
    styleUrls: ["./textarea-pill.component.scss"],
    templateUrl: "./textarea-pill.component.html",
    standalone: false
})
export class FUITextareaPillComponent extends FUIAbstractPill {
}
